export const SAMPLE = 1;
export const PRESET = 2;
export const PROJECT = 3;
